const emptyData = {
  Subject: [],
  Message: '',
  Description: '',
  Note: ''
}

const validationRules = {
  StatusFu: [
    {
      required: true,
      trigger: 'change'
    }
  ],
  Description: [
    {
      required: true,
      trigger: 'blur'
    }
  ],
  Note: [
    {
      required: true,
      trigger: 'blur'
    }
  ]
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
